/**
 * Selectors over the currentIdentity object.
 *
 * Keep all derived predicates here so route guards, menu gating and component
 * visibility logic share a single source of truth. If the rule for "does this
 * user have access to Drive features" ever changes (e.g. requires a specific
 * active outlet, or requires a permission combo), update it in ONE place.
 */

/**
 * True when at least one of the user's accessible outlets has the Drive licence.
 * Safe to call with an undefined/null identity or missing outlets array.
 *
 * @param {object} currentIdentity
 * @returns {boolean}
 */
export const selectHasAnyDriveLicenceOutlet = (currentIdentity) =>
  !!currentIdentity?.accessibleMoboOutlets?.some((o) => o.hasDriveLicence);

/**
 * Subset of accessible outlets that have the Drive licence. Returns an empty
 * array when identity/outlets are missing, so callers can spread/map safely.
 *
 * @param {object} currentIdentity
 * @returns {Array}
 */
export const selectDriveLicenceOutlets = (currentIdentity) =>
  currentIdentity?.accessibleMoboOutlets?.filter((o) => o.hasDriveLicence) ?? [];
